export default "__VITE_PUBLIC_ASSET__565a677b__"